<template>
  <div>
    <div class="account">
      <UpdateUserDialog
          :showDialog="showUpdateUserDialog"
          :user="selectedUser || {}"
          @closeDialog="showUpdateUserDialog = false"
          @refreshData="refreshData"
      />
      <UpdateAccountDialog
          :showDialog="showUpdateAccountDialog"
          :account="selectedAccount || {}"
          @closeDialog="showUpdateAccountDialog = false"
          @refreshData="refreshData"
      />
      <div class="accounts-wrapper">
        <div class="copy-btn">
          <i @click="copyToBuffer" :plain="true" class="el-icon-document-copy" />
          <input type="text" ref="copyInput" class="copy-to-buffer-input">
        </div>
        <div class="select-wrapper">
          <el-select
              v-model="selectedUser"
              filterable
              placeholder="User login"
              class="select"
              value-key="login"
              no-data-text="List is empty"
              no-match-text="User not found"
          >
            <el-option
                v-for="item in userList"
                :key="item.id"
                :label="item.login"
                :value="item"
            >
            </el-option>
          </el-select>
          <p v-if="errorMessage && !selectedUser" class="errorMessage">{{ errorMessage }}</p>
          <div class="account-info" v-if="selectedUser">
            <span><b>Client ID:</b> {{selectedUser.client_id}}<br></span>
            <span><b>Name:</b> {{selectedUser.first_name}} {{selectedUser.last_name}}</span>
            <span><b>Email:</b> {{selectedUser.email}}</span>
            <span><b>Phone Number:</b> {{selectedUser.phone_number}}</span>
            <span><b>Company Name:</b> {{selectedUser.company_name}}</span>
            <span><b>Country:</b> {{selectedUser.country_name}}</span>
            <span><b>State or Province:</b> {{selectedUser.state_or_province}}</span>
            <span><b>City:</b> {{selectedUser.city}}</span>
            <span><b>Address:</b> {{selectedUser.address}}</span>
            <el-button
                class="button"
                type="success"
                @click="showUpdateUserDialog = true"
            >
              Update
            </el-button>
            <el-button
                class="button"
                type="primary"
                @click="resetPassword"
                :plain="true"
                :loading="disabledResetBtn"
            >
              Reset Password
            </el-button>
          </div>
        </div>

        <div class="select-wrapper">
          <el-select
            v-model="selectedAccount"
            filterable placeholder="Accounts"
            class="select" value-key="account_special_number"
            no-data-text="List is empty"
            no-match-text="Account not found"
          >
            <el-option
                v-for="item in accountsList"
                :key="item.id"
                :label="`${item.account_special_number} (${item.currency_abbreviation})`"
                :value="item"
            >
            </el-option>
          </el-select>
          <p v-if="errorMessage && !selectedAccount" class="errorMessage">{{ errorMessage }}</p>
          <div v-if="selectedAccount" class="account-info">
            <span><b>Account Type:</b> {{selectedAccount.account_type_name}}<br></span>
            <span><b>Agent:</b> {{selectedAccount.agent_name}}</span>
            <span><b>Balance:</b> {{selectedAccount.balance}}</span>
            <span><b>Min Balance:</b> {{selectedAccount.min_balance}}</span>
            <span v-if="selectedAccount.description"><b>Description:</b> {{selectedAccount.description}}</span>
            <el-button
                class="button"
                type="success"
                @click="openAccountUpdDialog"
            >
              Update
            </el-button>
          </div>
        </div>

        <div class="select-wrapper">
          <el-select v-model="selectedOperation" placeholder="Operation" class="select">
            <el-option
                v-for="item in operationList"
                :key="item.id"
                :label="item.label"
                :value="item.id"
            >
            </el-option>
          </el-select>
          <p v-if="errorMessage && !selectedOperation" class="errorMessage">{{ errorMessage }}</p>
        </div>

        <div>
          <div class="select-wrapper">
            <el-input class="input" placeholder="Amount" v-model="amount" type="number"></el-input>
            <p v-if="errorMessage && !amount" class="errorMessage">{{ errorMessage }}</p>
          </div>

          <div class="select-wrapper">
            <el-input class="input references" placeholder="Reference" v-model="references"></el-input>
            <p v-if="errorMessage && !references" class="errorMessage">{{ errorMessage }}</p>
          </div>

          <div>
            <el-button
                class="button"
                type="success"
                @click="accountOperation"
                :loading="disabledSubmitBtn"
                :disabled="disabledSubmitBtn"
            >
              Submit
            </el-button>
            <el-button
                v-if="selectedAccount"
                class="button"
                type="success"
                :disabled="disabledStatementBtn"
                :loading="disabledStatementBtn"
                @click="getTransactionList"
            >
              Statement
            </el-button>
          </div>
        </div>
      </div>
      <div class="table-wrapper">
        <StatementTable v-if="transactionList" :transactionList="transactionList" />
      </div>
    </div>

    <div class="account-print">
      <div class="flex">
        <img class="print-bg-top" src="../../assets/sekerTop.png" />
        <div class="fake_div">

        </div>
      </div>
      <div class="account-info-wrapper">
        <div v-if="selectedUser" class="block">
          <span><b>Login:</b> {{selectedUser.login}}<br></span>
          <span><b>Client ID:</b> {{selectedUser.client_id}}<br></span>
          <span><b>Name:</b> {{selectedUser.first_name}} {{selectedUser.last_name}}</span>
          <span><b>Email:</b> {{selectedUser.email}}</span>
          <span><b>Phone Number:</b> {{selectedUser.phone_number}}</span>
          <span><b>Company Name:</b> {{selectedUser.company_name}}</span>
          <span><b>Country:</b> {{selectedUser.country_name}}</span>
          <span><b>State or Province:</b> {{selectedUser.state_or_province}}</span>
          <span><b>City:</b> {{selectedUser.city}}</span>
          <span><b>Address:</b> {{selectedUser.address}}</span>
        </div>

        <div v-if="selectedAccount" class="block">
          <span><b>Special Number:</b> {{selectedAccount.account_special_number}}<br></span>
          <span><b>Account Type:</b> {{selectedAccount.account_type_name}}<br></span>
          <span><b>Agent:</b> {{selectedAccount.agent_name}}</span>
          <span><b>Balance:</b> {{selectedAccount.balance}}</span>
          <span><b>Min Balance:</b> {{selectedAccount.min_balance}}</span>
          <span><b>Description:</b> {{selectedAccount.description}}</span>
        </div>
      </div>
      <div style="margin: 0 auto;">
        <div class="print-table-wrapper">
          <StatementTablePrint v-if="transactionList" :transactionList="transactionList" />
        </div>
      </div>

      <img class="print-bg-bottom" src="../../assets/sekerBottom.jpg" />
    </div>
  </div>
</template>

<script>
  import {required} from "vuelidate/lib/validators";
  import UpdateUserDialog from "./UpdateUserDialog";
  import UpdateAccountDialog from "./UpdateAccountDialog";
  import StatementTable from "./statementTable";
  import StatementTablePrint from "./statementTablePrint.vue";

  export default {

    validations: {
      amount: {required},
      references: {required},
      selectedUser: {required},
      selectedAccount: {required},
      selectedOperation: {required}
    },

    data() {
      return {
        selectedUser: null,
        selectedAccount: null,
        selectedOperation: null,
        operationList: [
          {id: 1, label: 'Crediting'},
          {id: 2, label: 'Withdrawal'}
        ],
        amount: null,
        references: null,
        disabledSubmitBtn: false,
        disabledStatementBtn: false,
        disabledResetBtn: false,
        errorMessage: '',
        showUpdateUserDialog: false,
        showUpdateAccountDialog: false,
        transactionList: null,
      }
    },

    async mounted() {
      const userList = await this.$store.dispatch('request', {
        path: 'admin/gets/users/lists', body: {}
      });
      // const isSuperAdmin = await this.$store.dispatch('request', {
      //   path: 'admin/supers/admins/checks', body: {}
      // });

      this.$store.commit('setUserList', userList)
      // this.$store.commit('setIsSuperAdmin', isSuperAdmin)
    },

    methods: {
      async resetPassword() {
        this.disabledResetBtn = true
        await this.$store.dispatch('request', {
          path: 'admin/resets/passwords', body: {id: this.selectedUser.id}
        }).then((result) => {
          this.$message({
            message: result,
            type: 'success',
          })
        }).catch((result) => {
          this.$message({
            message: result,
            type: 'warning',
          })
        });
        this.disabledResetBtn = false

      },

      copyToBuffer() {
        if (!this.selectedUser) return

        const copyInput = this.$refs.copyInput

        copyInput.value = this.selectedUser.login
        copyInput.select()
        document.execCommand('copy')
        this.$message(`"${this.selectedUser.login}" copied to clipboard`)
      },

      async openAccountUpdDialog() {
        const accountTypeList = await this.$store.dispatch('request', {
          path: 'admin/gets/accounts/types/lists', body: {
            id: this.user_selected
          }
        });
        this.$store.commit('setAccountTypeList', accountTypeList)

        this.showUpdateAccountDialog = true
      },

      async accountOperation() {
        // eslint-disable-next-line no-console
        console.log('accountOperation')
        if (this.$v.$invalid) {
          this.errorMessage = 'All field must be filled'
          return;
        }

        this.disabledSubmitBtn = true;

        await this.$store.dispatch('request', {
          path: 'admin/accounts/operations', body: {
            account: this.selectedAccount.id,
            operation: this.selectedOperation,
            reference: this.references,
            amount: this.amount,
          }
        }).finally(async () => {
          this.disabledSubmitBtn = false
          this.selectedOperation = null
          this.references = null
          this.amount = null
          this.errorMessage = ''
        });
      },

      async refreshData() {
        const userList = await this.$store.dispatch('request', {
          path: 'admin/gets/users/lists', body: {}
        });
        this.$store.commit('setUserList', userList)

        const accountsList = await this.$store.dispatch('request', {
          path: 'admin/gets/users/accounts/lists', body: {
            id: this.selectedUser.id
          }
        });
        this.$store.commit('setAccountsList', accountsList)

       this.selectedUser = null
       this.selectedAccount = null
      },

      async getTransactionList() {
        this.disabledStatementBtn = true

        this.transactionList = await this.$store.dispatch('request', {
          path: 'admin/gets/transactions/lists',
          body: {
            id: this.selectedAccount.id,
          }
        }).finally(() => {
          this.disabledStatementBtn = false;
        });
      },
    },

    watch: {
      async selectedUser(value) {
        this.selectedAccount = null
        this.selectedOperation = null
        this.transactionList = null

        if (value) {
          const accountsList = await this.$store.dispatch('request', {
            path: 'admin/gets/users/accounts/lists', body: {
              id: this.selectedUser.id
            }
          });
          this.$store.commit('setAccountsList', accountsList)
        }
      },
      async selectedAccount() {
        this.transactionList = null
      }
    },

    computed: {
      userList: function() {
        return this.$store.state.userList || []
      },
      accountsList: function() {
        return this.$store.state.accountsList || []
      },
      isSuperAdmin: function() {
        return this.$store.state.isSuperAdmin
      }
    },

    components: {StatementTablePrint, UpdateUserDialog, UpdateAccountDialog, StatementTable },
  }
</script>

<style lang="scss" scoped>

  .account {
    @media print {
      display: none;
    }
  }

  .account-print {
    display: none;

    @media print {
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      align-items: flex-end;
      min-height: 100vh;
      height: 100%;
      width: 100%;
    }
  }

  .flex {
    display: flex;
    justify-content: space-between;

    .print-bg-top {
      height: auto;
      width: auto;
    }

    .fake_div {
      width: 300px;
      height: 300px;
    }
  }

  .print-bg-bottom {
    height: 250px;
    width: 90%;
  }

  .table-wrapper {
    display: flex;
    justify-content: center;
    padding: 40px;
  }

  .accounts-wrapper {
    display: flex;
    flex-direction: row;
    justify-content: center;
    padding: 40px;
  }

  .copy-btn {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 60px;
    height: 52px;
    cursor: pointer;
    font-size: 18px;
  }

  .copy-to-buffer-input {
    position: absolute;
    top: -2000px;
  }

  .account-info,
  .select-wrapper {
    display: flex;
    flex-direction: column;
    margin-bottom: 15px;
  }

  .select-wrapper {
    margin-right: 25px;
    width: 300px;
  }

  .references {
    width: 300px;
  }

  .button {
    background-color: #26a69a;
    height: 40px;
    padding: 10px;
    margin-top: 10px;
  }

  .errorMessage {
    color: #cc3f55;
    margin-top: -5px;
  }

  .update-form-wrapper {
    display: flex;
    flex-direction: column;
  }

  .print-table-wrapper {
    width: 100%;
    overflow-x: hidden;
  }

  .account-info-wrapper {
    display: flex;
    justify-content: space-between;
    margin-bottom: 10px;
    padding: 0 30px;
    font-size: 12px;

    .block {
      display: flex;
      flex-wrap: wrap;

      span {
        display: block;
        margin-right: 10px;
      }
    }
  }

  .el-button--primary {
    margin-left: 0 !important;
    color: white !important;
    background: #cc3f55 !important;
  }

</style>
